<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #ac8400">Report</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #f2f2f2">
      <router-link to="/dashboard">Dashboard</router-link> /
      <b>Payout Report</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-3">
      <div class="col-12 col-lg-6 col-sm-12">
        <!-- <router-link to="/payout/update" type="button" class="btn btn-primary mb-2 pull-right">Upload</router-link> -->
      </div>

      <div
        class="
          col-12 col-lg-6 col-sm-12
          d-flex
          flex-column flex-sm-row
          align-items-center
        "
      >
        <span class="m-auto"></span>
        <!-- <div class="btn-group col-lg-6 col-sm-12 pl-0 pl-sm-3" role="group">
                <button class="btn btn-secondary" id="btn-active" type="button" @click="active()">Active</button>
                <button class="btn btn-secondary" id="btn-pending" type="button" @click="pending()">Pending</button>
            </div> -->
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">
            <div id="active" class="">
              <h4 class="card-title mb-3">
                <b>Overall Report</b>
              </h4>
              <!-- <p>The table shows the list of monthly reports.</p> -->

              <!-- <div class="row form-group">
                    <div class="col-8">
                    </div>
                    <div class="col-4">
                        <label><b>Filter By:</b></label>
                        <select class="form-control" v-model="filter">
                            <option value="month">Month</option>
                            <option value="year">Year</option>
                        </select>
                    </div>
                </div> -->

              <!-- Active -->
              <div class="table-responsive">
                <table
                  id="payout_tbl"
                  class="display table table-striped table-bordered"
                  style="width: 100%; text-align: center"
                >
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Month</th>
                      <th>Year</th>
                      <th>Total Earn ($)</th>
                      <th>Invoice</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(payout, index) in payouts" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ payout.month }}</td>
                      <td>{{ payout.year }}</td>
                      <td>{{ payout.total }}</td>
                      <td>
                        <span v-if="payout.invoice_url == null"
                          >Invoice Not Uploaded</span
                        >
                        <span v-else>Invoice Uploaded</span>
                      </td>
                      <td>{{ payout.cashed }}</td>
                      <td>
                        <router-link
                          :to="redirect(payout.id, payout.month, payout.year)"
                          class="btn btn-primary btn-rounded btn-block"
                        >
                          View Details
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


    <script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "vendor-payout",
  components: {},

  data() {
    return {
      payouts: [],
    };
  },

  methods: {
    loadPayout() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/payout", {
            headers: {
              Authorization: "Bearer " + token,
            },
          })
          .then((res) => {
            this.payouts = res.data.payouts;

            let months = [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ];
            this.payouts.forEach((payout) => {
              let month = payout.month - 1;
              payout.month = months[month];

              if (payout.cashed == 1) {
                payout.cashed = "Paid";
              } else {
                payout.cashed = "Not Paid";
              }
            });
          })
          .then(function () {
            $("#payout_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: ["excel", "pdf"],
            });
          });
      }
    },

    loadData() {
      this.destroyDatatable();
      this.loadPayout();
    },

    destroyDatatable() {
      $("#payout_tbl").DataTable().destroy();
    },

    redirect(id, month1, year) {
      let months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      let month = months.indexOf(month1) + 1;

      return "/payout/view/" + id + "/" + month + "/" + year;
    },
  },

  mounted() {
    this.loadData();
  },
};
</script>
